import * as React from 'react';
/**
 *
 * Original name: folder
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3704%3A550
 *
 */
export const FolderSpot = (props) => (React.createElement("svg", { viewBox: "0 0 120 120", fill: "none", ...props },
    React.createElement("path", { d: "m58.477 30-6.1-7.926A13.08 13.08 0 0 0 42.076 17H13v69a13.014 13.014 0 0 0 13 13h68a13.015 13.015 0 0 0 13-13V30H58.477ZM101 86a7.006 7.006 0 0 1-7 7H26a7.008 7.008 0 0 1-7-7V23h23.076a7.043 7.043 0 0 1 5.548 2.732L55.523 36H101v50Z", fill: "currentColor" })));
